
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[business]/access/guides",
      function () {
        return require("private-next-pages/[lang]/[business]/access/guides.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[business]/access/guides"])
      });
    }
  